import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { getCategories } from '../api';
import './Navbar.css';

const STATIC_ITEMS = [
  { label: '首页', to: '/' },
  { label: '新闻中心', to: '/news' },
  {
    label: '关于我们', children: [
      { label: '企业简介', to: '/about' },
      { label: '生态伙伴', to: '/about/partner' },
      { label: '资质荣誉', to: '/about/qualification' },
      { label: '企业文化', to: '/about/culture' },
    ]
  },
  { label: '加入我们', to: '/recruit' },
];

const TYPE_LABEL = { industry: '行业方案', product: '产品方案' };

// 递归扁平化分类树
function flattenTree(tree, results = []) {
  if (!tree) return results;
  tree.forEach(node => {
    results.push(node);
    if (node.children && node.children.length > 0) {
      flattenTree(node.children, results);
    }
  });
  return results;
}

export default function Navbar({ onGetSolution }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [industryChildren, setIndustryChildren] = useState([]);
  const [productChildren, setProductChildren] = useState([]);
  const navRef = useRef(null);

  useEffect(() => {
    // 使用 v2.0 分类树 API，替代旧的 getIndustries()
    getCategories().then(tree => {
      const industries = [];
      const products = [];
      const flat = flattenTree(tree || []);
      flat.forEach(cat => {
        const item = { label: cat.name, to: `/category/${cat.id}` };
        if (cat.type === 'industry') industries.push(item);
        else products.push(item);
      });
      setIndustryChildren(industries);
      setProductChildren(products);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Build nav items dynamically: insert industry/product dropdowns after 首页
  const navItems = [];
  STATIC_ITEMS.forEach(item => {
    navItems.push(item);
    if (item.to === '/') {
      // After 首页, insert 行业方案 and 产品方案 dropdowns
      if (industryChildren.length > 0) {
        navItems.push({ label: TYPE_LABEL.industry, children: industryChildren });
      }
      if (productChildren.length > 0) {
        navItems.push({ label: TYPE_LABEL.product, children: productChildren });
      }
    }
  });

  return (
    <header className={`navbar${scrolled ? ' scrolled' : ''}`} ref={navRef}>
      <div className="navbar-inner container">
        <Link to="/" className="navbar-logo">
          <img src="/images/logo.png" alt="和正网络科技" className="logo-img" />
        </Link>

        <nav className={`navbar-nav${menuOpen ? ' open' : ''}`}>
          {navItems.map((item, idx) =>
            item.children ? (
              <div
                key={idx}
                className={`nav-item has-dropdown${openDropdown === idx ? ' active' : ''}`}
                onMouseEnter={() => setOpenDropdown(idx)}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <span className="nav-link">{item.label} <i className="arrow">▾</i></span>
                <div className="dropdown">
                  {item.children.map((child, cidx) => (
                    <Link key={cidx} to={child.to} className="dropdown-item" onClick={() => setMenuOpen(false)}>
                      {child.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <NavLink
                key={idx}
                to={item.to}
                className={({ isActive }) => `nav-item nav-link${isActive ? ' active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="navbar-actions">
          <button className="btn btn-primary btn-sm" onClick={onGetSolution}>获取方案</button>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </div>
      </div>
    </header>
  );
}
